<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-country-server-select :width="['120px', '150px']" v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select v-model="filter.templateType" :options="templateTypeOptions" placeholder="规则类型" style="width:120px">
        </gj-select>
        <gj-select
          v-model="filter.status"
          :options="[
            { id: 'Active', text: '启用' },
            { id: 'Inactive', text: '停用' },
          ]"
          style="width:120px"
          placeholder="规则状态"
        ></gj-select>
        <gj-creator-select placeholder="创建用户" width="120px" v-model="filter.userId"></gj-creator-select>
        <gj-creator-select placeholder="更新用户" width="120px" v-model="filter.updateUserId"></gj-creator-select>
        <gj-select-date-picker v-model="filter.date" :options="[
          { id: 'create', text: '创建时间' },
          { id: 'update', text: '更新时间' },
        ]" type="daterange"></gj-select-date-picker>
        <gj-select-input v-model="filter.keyword" :options="saleOrderDynKey"
          :width="clientWidth > 1366 ? ['120px', '200px'] : ['120px', '100px']"></gj-select-input>
          <template  #right>
            <view-setting style="margin-left: 15px;" :ref="REF_VIEW_SETTING" save-mode="remote" :use-default="false"
              :module-name="moduleName" :config="model" :fn-generate-params="generateViewParams"
              @view-change="handleChangeView" @view-complete="handCompleteView">
            </view-setting>
          </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('requestRule:add')" type="primary"
        @click="$router.push({ path: '/crm/send-rule-add/add' })">新增规则</gj-button>
      <template v-if="$permission('requestRule:edit')">
        <gj-button @click="batchEnable" :disabled="!selectedAllIs('status', option.sendRuleStatus[1].id) || emailNumber <= 0 || orderNumber <= 0">批量启用
        </gj-button>
        <gj-button @click="batchDisable" :loading="statusLoading" :disabled="!selectedAllIs('status', option.sendRuleStatus[0].id) || emailNumber <= 0 || orderNumber <= 0">批量关闭
        </gj-button>
      </template>
    </template>
    <template #tool-group>
      <div class="tool-group-mail">
        <span class="weight600">今日额度</span>
        <gj-tooltip class="item" effect="dark" style="margin-right: 10px;">
          <div slot="content">使用说明：亚马逊规定卖家每日给买家<br/>发邮件的数量在(600+5*日均单量)之内<br/>计算公式：所有店铺站点发件额度之和</div>
          <i class="el-icon-question fontsize12 colorD8DADD gj-ml5"></i>
        </gj-tooltip>
        <el-progress
          :text-inside="true"
          :stroke-width="14"
          :show-text="false"
          :percentage="mailPackForm.alreadySendMailRate"
          :color="mailPackForm.color"
          style="width:63px; border-radius: 4px; margin-right: 10px;">
          </el-progress>
        <span class="size14" :style="{color: mailPackForm.color}">剩余{{ mailPackForm.dayExcessMailCount }}</span>
        <gj-button type="text" :loading="limitLoading" style="color:#1F6EEF;margin-left:10px;cursor: pointer" @click="limitDetails">详情></gj-button>
      </div>
      <gj-tool-group help log :download="$permission('purchasePlan:export')" download-url="crm/requestRule/export"
        :download-params="globalParams" @viewLog="viewLog">
      </gj-tool-group>
    </template>

    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        :data="data"
        :columns="columns"
        :selection="true"
        :loading="loading"
        :pagination="pagination"
        show-summary
        :summary-object="summaryData"
        :summary-method="summaryMethod"
        :show-overflow="false"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
        @footer-cell-click="footerCellCilck"
        :default-sort="defaultSort">
        <template v-slot:mailTitle="{ row }">
          <template v-if="row.templateType == 'AMAZON_REQUEST_REVIEW'">
         {{row.mailTitle | defaultShow}}
          </template>
          <template v-else>

            <gj-popover trigger="hover" @show="getPopoverContent(row)" placement="left" @after-leave="popoverContent=''">
              <template slot="reference">
                <gj-link >{{row.mailTitle | defaultShow}}</gj-link>
              </template>
              <div class="popoverContent" v-html="popoverContent">
              </div>
            </gj-popover>
          </template>
        </template>
        <template v-slot:finishSend="{ row }">
          <gj-link @click="mailReply(row, '')">{{row.finishSend}}</gj-link>
        </template>
        <template v-slot:sendSuccess="{ row }">
          <gj-link @click="mailReply(row, 1)">{{row.sendSuccess}}</gj-link>
        </template>
        <template v-slot:sendFail="{ row }">
          <gj-link @click="mailReply(row, 0)">{{row.sendFail}}</gj-link>
        </template>
        <template v-slot:status="{ row }">
          <gj-switch size="small" :disabled="emailNumber <= 0 || (orderNumber <= 0 && row.templateType !== 'AMAZON_REQUEST_REVIEW')" v-loading="row.statusLoading" :value="row.status == 'Active'" @input="switchStatus($event, row)"></gj-switch>
        </template>
        <template v-slot:op="{ row }">
          <gj-button type="text" @click="$router.push({ path: `/crm/send-rule-view/view/${row.id}` })">查看
          </gj-button>
          <gj-button type="text" :disabled="row.status == 'Active' || emailNumber <= 0 || (orderNumber <= 0 && row.templateType !== 'AMAZON_REQUEST_REVIEW')" @click="$router.push({ path: `/crm/send-rule-edit/edit/${row.id}` })"
            v-if="$permission('requestRule:edit') && row.status !== option.sendRuleStatus[2].id">编辑
          </gj-button>
          <gj-button type="text" :disabled="emailNumber <= 0 || (orderNumber <= 0 && row.templateType !== 'AMAZON_REQUEST_REVIEW')" @click="$router.push({ path: '/crm/send-rule-add/add', query: { id: row.id } })"
            v-if="$permission('requestRule:add')">复制
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { sendRuleStatus } from "../../../../utils/options";
import { queryMixin, isMeaningfulMixin, selectionMixin } from "../../../../minxins";
import SendRuleLog from './modal/send-rule-log';
import { editSendRuleStatus, mailHover, getSendRule, summaryPage, getSendRuleDetail,  mailPack, requestRuleDetalStatus, countNotExecuteRecord } from "../../../../api/crm";
import { mapGetters } from "vuex";
import { tagColors } from "@/components/tag/tag-colors";
import LimitDetails from './modal/limit-details';
import { viewSetting, templateTypeOptions } from './viewConfig'
import { isMeaningful } from "@/utils/common";
import { generateViewParams, convertToDate } from "./../../../../utils/date.util";
import {getTenantOrderDetailed} from "@/api/user";
export default {
  name: "send-rule",
  mixins: [selectionMixin, queryMixin, isMeaningfulMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  data() {
    return {
      moduleName: 'SEND_RULE',
      templateTypeOptions,
      model: viewSetting,
      tagColors,
      data: [],
      summaryData: [],
      // sumRecord: {},
      columns: [
        { id: 'templateType', header: '关怀邮件类型', field: 'option:templateType', options: () => templateTypeOptions, minWidth: '150px', },
        { id: 'name', header: '规则名称', field: 'name', minWidth: '150px', default: true, overflowLine: 2 },
        { id: 'mailTitle', header: '邮件主题', field: 'slot:mailTitle', minWidth: '150px', default: true },
        { id: 'availableCountry', header: '适用国家', field: 'availableCountry', minWidth: '150px', default: true, overflowLine: 2 },
        { id: 'availableMarket', header: '适用店铺', field: 'availableMarket', minWidth: '150px', default: true, overflowLine: 2 },
        { id: 'notSend', header: '待发送', field: 'notSend', minWidth: '120px', default: true },
        { id: 'finishSend', header: '已发送', summary: true, field: 'slot:finishSend', minWidth: '120px', default: true },
        { id: 'sendSuccess', header: '发送成功', summary: true, field: 'slot:sendSuccess', minWidth: '120px', default: true },
        { id: 'sendFail', header: '发送失败', summary: true, field: 'slot:sendFail', minWidth: '120px', default: true },
        { id: 'createUserName', header: '创建用户', field: 'createUserName', minWidth: '110px', default: true },
        { id: 'updateUserName', header: '最近更新用户', field: 'updateUserName', minWidth: '110px', default: true },
        { id: 'createTime', header: '创建日期', field: 'createTime', minWidth: '160px', default: true, sortable: true, },
        { id: 'updateTime', header: '更新日期', field: 'updateTime', minWidth: '160px', default: true, sortable: true, },
        { id: 'status', header: '状态', field: 'slot:status', minWidth: '80px', default: true },
        { id: 'op', header: '操作', field: 'slot:op', fixed: 'right', width: '150px', default: true, notCustomColumn: true }
      ],
      loading: false,
      statusLoading: false,
      limitLoading: false,
      filter: {
        countryMarketValue: null,
        templateType: '',
        status: 'Active',
        updateUserId: null,
        userId: null,
        date: {
          key: 'create',
          value: null,
        },
        keyword: {
          key: 'asinList',
          value: null,
        }
      },
      option: {
        sendRuleStatus: sendRuleStatus,
      },
      defaultSort: {
        order: '',
        prop: ''
      },
      notStorage: true,
      type: null,
      saleOrderDynKey: [
        { id: "asinList", text: "ASIN", moreShow: true },
        { id: "name", text: "规则名称", moreShow: false },
      ],
      dateKey: [
        { id: 'create', text: '创建时间' },
        { id: 'update', text: '更新时间' },
      ],
      mailPackForm: {},
      globalParams: {},
      popoverContent: '',
      orderNumber: 0,
      emailNumber: 0,
    }
  },
  created() {
    this.getMailPack();
    this.getOderNumber();
  },
  activated() {
    this.$gjNoticeQuery();
    this.getMailPack();
    this.getOderNumber();
  },
  methods: {
    generateViewParams,
    // 获取额度信息
    getMailPack(callback = () => {}) {
      this.limitLoading = true
      mailPack().then(res => {
        res.alreadySendMailRate = Number(res.alreadySendMailRate)
        if(res.alreadySendMailRate >= 90) {
          res.color = '#F5222D'
        }else if(res.alreadySendMailRate >= 60) {
          res.color = '#ED6A0C'
        }else {
          res.color = '#2DA641'
        }
        res.dayExcessMailCount = this.moneyFormat(res.dayExcessMailCount)
        res.marketMailDetailList.forEach(item => {
          item.alreadySendMailRate = Number(item.alreadySendMailRate)
          if(item.alreadySendMailRate >= 90) {
            item.color = '#F5222D'
          }else if(item.alreadySendMailRate >= 60) {
            item.color = '#ED6A0C'
          }else {
            item.color = '#2DA641'
          }
        });
        this.mailPackForm = res;
      }).complete(res => { this.limitLoading = false, callback() })
    },
    //获取订单剩余量
    getOderNumber() {
      getTenantOrderDetailed().then(res => {
        if(isMeaningful(res)) {
          //当订单剩余量===0时，先取免费订单量
          this.orderNumber = res.usableOrder === null || res.usableOrder === 0 ? (res.freeOrder  ? res.freeOrder : 0) : res.usableOrder;
          this.emailNumber = res.remainingEmail ? res.remainingEmail : 0;
        }
      })
    },
    // 整数金额格式化
    moneyFormat (num) {
      return String(num).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    },
    getStatus(status) {
      switch (status) {
        case 'Active':
          return '启用';
        case 'Inactive':
          return '禁用';
        case 'Close':
          return '归档';
      }
    },
    getColor(status) {
      switch (status) {
        case 'Active':
          return this.tagColors.greenText;
        case 'Inactive':
          return this.tagColors.gray9Text;
        case 'Close':
          return this.tagColors.gray6Text;
      }
    },
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          name: this.filter.name,
          userId: this.filter.userId,
          status: this.filter.status,
          updateUserId: this.filter.updateUserId,
          templateType: this.filter.templateType
        },
        ...this.queryPagination,
        ...this.querySort
      };
      if (this.filter.countryMarketValue) {
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
      }
      if (isMeaningful(this.filter.date) && isMeaningful(this.filter.date.value)) {
        params.model[this.filter.date.key + 'StartTime'] = convertToDate(this.filter.date.value[0]);
        params.model[this.filter.date.key + 'EndTime'] = convertToDate(this.filter.date.value[1]);
      }
      if (this.filter.keyword.key == 'asinList') {
        params.model[this.filter.keyword.key] = this.filter.keyword.value ? this.filter.keyword.value.split(',') : [];
      } else {
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
      }
      this.globalParams = params;
      getSendRule(params)
        .then((data) => {
          data.records.forEach(item => {
            item.statusLoading = false
          })
          this.data = data.records;
          this.pagination = this.getPagination(data);
        })
        .complete(() => this.loading = false)
      summaryPage(params)
        .then((data) => {
          this.summaryData = ['总计', '', '', '', '', '', '',  data.notSend, data.finishSend, data.sendSuccess, data.sendFail, '', '', '', '', '', '']
        })
    },
    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: null,
          templateType: '',
          status: 'Active',
          updateUserId: null,
          userId: null,
          date: {
            key: 'create',
            value: null,
          },
          keyword: {
            key: 'asinList',
            value: null,
          }
        },
      }
    },
    summaryMethod() {
      if (this.summaryData) {
        return this.summaryData
      } else {
        return [];
      }
    },
    batchEnable() {
      const rows = this.selectedRows.map(v => v.id);
      const status = this.option.sendRuleStatus[0].id;
      const vm = this;
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: '确认开启',
          content: `已经选择 ${rows.length} 条数据，是否确认开启？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            modal.confirmLoading = true;
            editSendRuleStatus({
              ids: rows,
              status: status
            }).complete(() => modal.confirmLoading = false)
              .then(() => {
                vm.$gjMessage.success('操作成功');
                vm.$gjResetPage();
                modal.$gjDestroy();
              });
          }
        },
      });
    },
    batchDisable() {
      const rows = this.selectedRows.map(v => v.id);
      this.statusLoading = true
      countNotExecuteRecord({
        marketIdList: [],
        ruleIdList: rows,
      }).then(res => {
        let notExecuteArr = []
        res.forEach(item => {
          if(item.notExecuteCount > 0) {
            notExecuteArr.push(`规则【${item.ruleName}】待发送条数：${item.notExecuteCount}`)
          }
        })
        if(notExecuteArr.length > 0) {
          this.enable(rows, `${notExecuteArr.join()}，请确认是否继续发送?`, true);
        }else {
          this.enable(rows, `关闭后，规则将立即停止发送关怀邮件，请确认是否关闭?`, false);
        }
      }).complete(() => this.statusLoading = false)
    },
    viewLog() {
      this.$gjCreate(SendRuleLog)
    },
    copyAdd(id) {
      this.$router.push({ path: '/crm/send-rule-add', query: { pageType: 'copy', id: id } })
    },
    limitDetails() {
      this.getMailPack(()=>{
        this.$gjCreate(LimitDetails, {
          props: {
            mailPackForm: this.mailPackForm
          }
        })
      })
    },
    switchStatus(open, row) {
      if (open) {
        this.open([row.id], '开启后，规则将立即生效，请确认是否开启?');
      } else {
        row.statusLoading = true;
        countNotExecuteRecord({
          marketIdList: row.availableMarketList,
          ruleIdList: [row.id],
        }).then(res => {
          if(res[0].notExecuteCount > 0) {
            this.enable([row.id], `此规则待发送条数：${res[0].notExecuteCount}条，请确认是否继续发送?`, true);
          }else {
            this.enable([row.id], `关闭后，规则将立即停止发送关怀邮件，请确认是否关闭?`, false);
          }
        }).complete(res => { row.statusLoading = false; })
      }
    },
    open(ids, content) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '确认开启',
          content: content
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            this.editSendRuleStatus(ids, modal, 'Active', false)
          }
        }
      })
    },
    enable(ids, content, type) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '确认关闭',
          content: content,
          confirmText: type ? '确认发送' : '确认',
          expandText: '确认不发送'
        },
        on: type ? {
          cancel: () => modal.$gjDestroy(),
          expand: () => {
            this.editSendRuleStatus(ids, modal, 'Inactive', false)
          },
          confirm: () => {
            this.editSendRuleStatus(ids, modal, 'Inactive', true)
          }
        } : {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            this.editSendRuleStatus(ids, modal, 'Inactive', false)
          }
        }
      });
    },
    editSendRuleStatus(ids, modal, status, sendExecuteRecord) {
      let params = {
        ids: ids,
        status: status,
        sendExecuteRecord: sendExecuteRecord // 是否需要发送待发送的规则(true:确认发送待发送的规则记录，false：确认不发送待发送的规则记录)
      }
      editSendRuleStatus(params).complete(() => modal.confirmLoading = false)
        .then(() => {
          this.$gjMessage.success('操作成功');
          this.$gjResetPage();
          modal.$gjDestroy();
        });
    },
    // 获取邮件内容
    getPopoverContent(row){
      mailHover(row.id).then(res=>{
        this.popoverContent = res.content;
      })
    },
    // 表尾跳转
    footerCellCilck({itemIndex,items}) {
      const arr = [8, 9, 10];
      const sendMap = {
        8: '',
        9: 1,
        10: 0
      };
      if(arr.includes(itemIndex)) {
        let sendStatus = sendMap[itemIndex];
        this.$router.push({ path: '/crm/mail-reply-manager', query: {  mailType: 'CareMail', sendStatus, timestamp: new Date().getTime() }})
      }
    },
    // 跳转邮件回复--关怀邮件
    mailReply(row, sendStatus) {
      if(row.mailType === 'HOLIDAYS_AUTO_REPLY') {
        this.$router.push({ path: '/crm/mail-reply-manager', query: {  mailType: 'BuyerEmail', key: 'ruleName', value: row.name, sendStatus: sendStatus, timestamp: new Date().getTime() }})
      } else {
        this.$router.push({ path: '/crm/mail-reply-manager', query: {  mailType: 'CareMail', key: 'ruleName', value: row.name, sendStatus: sendStatus, timestamp: new Date().getTime() }})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-group-mail {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 15px;
  font-size: 12px;
  img {
    cursor: pointer;
    margin: 4px 10px;
    width: 15px;
    height: 15px;
  }
}
.popoverContent {
  width: 300px;
  height: 200px;
  overflow: auto;
}
/deep/ .vxe-footer--row .vxe-footer--column {
  &:nth-child(9),&:nth-child(10),&:nth-child(11) {
    color: #1F6EEF;
    cursor: pointer;
  }
}
/deep/ .vxe-footer--column.col--checkbox {
  color: #333333;
  cursor: default;
}
</style>
